import { FC, PropsWithChildren, useEffect } from "react"
import { assessGPUPerformance } from "@/store/gpu-state"
import { assessIntelMac } from "@/store/intel-mac-assessment"
import { Sentry } from "@/telemetry/sentry"

export const GPUAssessment: FC<PropsWithChildren> = ({ children }) => {
	useEffect(() => {
		void assessGPUPerformance().catch(Sentry.captureException)
		void assessIntelMac().catch(Sentry.captureException)
	}, [])

	return <>{children}</>
}
